import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "dialog-mask"
};
const _hoisted_2 = {
  class: "schedule-content"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "date-time-row"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "repeat-settings"
};
const _hoisted_7 = {
  class: "weekday-buttons"
};
const _hoisted_8 = ["aria-pressed", "onClick"];
const _hoisted_9 = {
  class: "repeat-end"
};
const _hoisted_10 = {
  key: 2,
  class: "repeat-hint"
};
const _hoisted_11 = {
  class: "actions"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_time_picker = _resolveComponent("el-time-picker");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["schedule-dialog", {
      'desen-schedule-dialog': $props.institution === '得森'
    }])
  }, [_createElementVNode("h2", null, _toDisplayString($props.schedule ? "编辑日程" : "新增日程"), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("label", null, [_cache[15] || (_cache[15] = _createTextVNode("添加主题", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.title,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.title = $event),
    maxlength: "256",
    placeholder: "请填写"
  }, null, 8, ["modelValue"])]), $props.institution === '得森' && !$props.schedule ? (_openBlock(), _createElementBlock("label", _hoisted_3, [_cache[16] || (_cache[16] = _createTextVNode("日程类型 ", -1)), _createVNode(_component_el_select, {
    modelValue: $data.repeat,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.repeat = $event),
    class: "repeat-select",
    onChange: $options.repeatChanged
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "不重复",
      value: false
    }), _createVNode(_component_el_option, {
      label: "重复",
      value: true
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("label", null, [_createTextVNode(_toDisplayString($props.institution === '得森' && $data.repeat && !$props.schedule ? '开始日期' : '日程日期'), 1), _createVNode(_component_el_date_picker, {
    modelValue: $data.form.date,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.date = $event),
    type: "date",
    "value-format": "YYYY-MM-DD",
    format: "YYYY年MM月DD日",
    placeholder: "请选择日期",
    clearable: false
  }, null, 8, ["modelValue"])]), $props.institution === '得森' && $data.repeat && !$props.schedule && $data.endMode === 'date' ? (_openBlock(), _createElementBlock("label", _hoisted_5, [_cache[17] || (_cache[17] = _createTextVNode("结束日期 ", -1)), _createVNode(_component_el_date_picker, {
    modelValue: $data.repeatEndDate,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.repeatEndDate = $event),
    type: "date",
    "value-format": "YYYY-MM-DD",
    format: "YYYY年MM月DD日",
    placeholder: "请选择结束日期",
    clearable: false,
    "disabled-date": $options.disabledEndDate
  }, null, 8, ["modelValue", "disabled-date"])])) : _createCommentVNode("", true), _createElementVNode("label", {
    class: _normalizeClass({
      'repeat-time-label': $props.institution === '得森' && $data.repeat && !$props.schedule
    })
  }, [_cache[18] || (_cache[18] = _createTextVNode("时间段", -1)), _createVNode(_component_el_time_picker, {
    modelValue: $data.timeRange,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.timeRange = $event),
    "is-range": "",
    "range-separator": "至",
    "start-placeholder": "开始时间",
    "end-placeholder": "结束时间",
    format: "HH:mm",
    "value-format": "HH:mm"
  }, null, 8, ["modelValue"])], 2)]), !$props.schedule ? (_openBlock(), _createElementBlock("div", _hoisted_6, [$props.institution !== '得森' ? (_openBlock(), _createBlock(_component_el_select, {
    key: 0,
    modelValue: $data.repeat,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.repeat = $event),
    class: "repeat-select",
    onChange: $options.repeatChanged
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "不重复",
      value: false
    }), _createVNode(_component_el_option, {
      label: "重复",
      value: true
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true), $data.repeat ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekdayNames, (name, day) => {
    return _openBlock(), _createElementBlock("button", {
      key: day,
      type: "button",
      class: _normalizeClass({
        selected: $data.weekdays.includes(day)
      }),
      "aria-pressed": $data.weekdays.includes(day),
      onClick: $event => $options.toggleWeekday(day)
    }, _toDisplayString(name), 11, _hoisted_8);
  }), 128))]), _createElementVNode("label", null, _toDisplayString($props.institution === '得森' ? '截止方式' : '截止时间'), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_radio_group, {
    modelValue: $data.endMode,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.endMode = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio, {
      value: "date"
    }, {
      default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("截止日期", -1)])),
      _: 1,
      __: [19]
    }), _createVNode(_component_el_radio, {
      value: "never"
    }, {
      default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("永不截止", -1)])),
      _: 1,
      __: [20]
    })]),
    _: 1
  }, 8, ["modelValue"]), $data.endMode === 'date' && $props.institution !== '得森' ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 0,
    modelValue: $data.repeatEndDate,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.repeatEndDate = $event),
    type: "date",
    "value-format": "YYYY-MM-DD",
    format: "YYYY年MM月DD日",
    placeholder: "请选择截止日期",
    clearable: false,
    "disabled-date": $options.disabledEndDate
  }, null, 8, ["modelValue", "disabled-date"])) : _createCommentVNode("", true)])], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.schedule && $props.schedule.repeatId ? (_openBlock(), _createElementBlock("p", _hoisted_10, "此日程按星期重复，本次仅修改或删除当天。")) : _createCommentVNode("", true), _createElementVNode("label", null, [_cache[21] || (_cache[21] = _createTextVNode("日程安排", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.scheduleContent,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.scheduleContent = $event),
    type: "textarea",
    rows: 4
  }, null, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[22] || (_cache[22] = _createTextVNode("备注", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.remark,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.remark = $event),
    type: "textarea",
    rows: 4
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_11, [$props.schedule ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "danger",
    disabled: $data.saving,
    onClick: _cache[10] || (_cache[10] = (...args) => $options.remove && $options.remove(...args))
  }, "删除", 8, _hoisted_12)) : _createCommentVNode("", true), _createElementVNode("button", {
    class: "primary",
    disabled: $data.saving,
    onClick: _cache[11] || (_cache[11] = (...args) => $options.save && $options.save(...args))
  }, "确认", 8, _hoisted_13), _createElementVNode("button", {
    onClick: _cache[12] || (_cache[12] = $event => _ctx.$emit('close'))
  }, "取消")])], 2), _createVNode(_component_el_dialog, {
    modelValue: $data.showConflicts,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.showConflicts = $event),
    title: "以下日程有冲突，未排成功",
    width: "760px",
    "append-to-body": "",
    "close-on-click-modal": false,
    onClosed: $options.conflictsClosed
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[13] || (_cache[13] = $event => $data.showConflicts = false)
    }, {
      default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("知道了", -1)])),
      _: 1,
      __: [23]
    })]),
    default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString($data.savedWithConflicts ? "其余无冲突的日程已保存；以下日期、时段已跳过。" : "本次日程未保存；编辑时原日程保留。"), 1), _createVNode(_component_el_table, {
      data: $data.conflicts,
      "max-height": "420",
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        label: "日期",
        "min-width": "200"
      }, {
        default: _withCtx(({
          row
        }) => [_createTextVNode(_toDisplayString($options.conflictDateLabel(row)), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "period",
        label: "未排成功时段",
        width: "130"
      }), _createVNode(_component_el_table_column, {
        label: "冲突原因",
        "min-width": "250"
      }, {
        default: _withCtx(({
          row
        }) => [_createTextVNode(_toDisplayString(row.type) + "：" + _toDisplayString(row.title) + "（" + _toDisplayString(row.conflictPeriod) + "）", 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }, 8, ["modelValue", "onClosed"])]);
}